import React from "react";
import PropTypes from "prop-types";
import { ErrorBoundary } from "@lululemon/mwa-logger";
import { AccordionItem, AccordionStateless } from "@lululemon/ui-library";

import StoryBlocksMobile from "./story-blocks/story-blocks-mobile";
import StoryBlocksDesktop from "./story-blocks/story-blocks-desktop";
import { productEdHandleError } from "../../utils/product-education-logger";

import styles from "./why-you-love-this-accordion.module.scss";

function WhyYouLoveThisAccordion({
  accordionItems,
  doubleLinedText,
  materialAndCare,
  deviceType,
  handleAccordionItemClick,
  handleStoryBlocksMobileNavigation
}) {
  const { isMobile } = deviceType;
  const [expandedAccordionPanels, setExpandedAccordionPanels] = React.useState(
    accordionItems?.reduce(
      (panels, item, index) => Object.assign(panels, { [index]: true }, {}),
      {}
    )
  );

  return (
    <ErrorBoundary
      onError={(error) => productEdHandleError(error, "WYLT Accordion", "WYLT")}
    >
      {accordionItems && (
        <AccordionStateless
          id="wylt-accordion"
          className={styles.accordionWrapper}
          defaultTypeStyle="small"
          mobileTypeStyle="xsmall"
          setAutoHeight={false}
          expandedAccordionPanels={expandedAccordionPanels}
          onClickAccordionItem={(index) => {
            setExpandedAccordionPanels((prevState) => {
              return {
                ...prevState,
                [index]: !prevState[index]
              };
            });
            handleAccordionItemClick(
              accordionItems[index]?.fields?.title,
              index + 1,
              accordionItems.length
            );
          }}
          v2
        >
          {accordionItems.map((accordionItem, index) => {
            const isTypeFabric = accordionItem?.fields?.type === "Fabric";

            return (
              <AccordionItem
                key={accordionItem?.sys?.id || index}
                heading={accordionItem?.fields?.title}
              >
                {isMobile ? (
                  <StoryBlocksMobile
                    storyBlocks={accordionItem?.fields?.storyBlocks}
                    type={accordionItem?.fields?.type}
                    materialAndCare={isTypeFabric ? materialAndCare : null}
                    doubleLinedText={isTypeFabric ? doubleLinedText : ""}
                    deviceType={deviceType}
                    handleStoryBlocksMobileNavigation={
                      handleStoryBlocksMobileNavigation
                    }
                  />
                ) : (
                  <StoryBlocksDesktop
                    storyBlocks={accordionItem?.fields?.storyBlocks}
                    materialAndCare={isTypeFabric ? materialAndCare : null}
                    doubleLinedText={isTypeFabric ? doubleLinedText : ""}
                  />
                )}
              </AccordionItem>
            );
          })}
        </AccordionStateless>
      )}
    </ErrorBoundary>
  );
}

WhyYouLoveThisAccordion.defaultProps = {
  accordionItems: [],
  doubleLinedText: "",
  materialAndCare: {}
};

WhyYouLoveThisAccordion.propTypes = {
  accordionItems: PropTypes.array,
  doubleLinedText: PropTypes.string,
  materialAndCare: PropTypes.shape({
    sections: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  deviceType: PropTypes.shape({
    isMobile: PropTypes.bool,
    isTablet: PropTypes.bool,
    isDesktop: PropTypes.bool
  }).isRequired,
  handleAccordionItemClick: PropTypes.func,
  handleStoryBlocksMobileNavigation: PropTypes.func
};

export default WhyYouLoveThisAccordion;
